import React from "react"

import { getFormattedMessage } from "../../components/shared_components_registration"

export default function DashLoader() {
  return (
    <div
      style={{
        zIndex: "800",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div className="spinner-border text-primary text-center" role="status" />
      &nbsp;&nbsp;
      <h4 style={{ margin: "0" }}>
        {getFormattedMessage("general.loading", "Loading")}
        ...
      </h4>
    </div>
  )
}
